import React, { useEffect, useState } from "react";
import UpArrowIcon from "assets/Icons/UpArrow.svg";
import "./demodata.style.css";
import { useSelector } from "react-redux";
import { AppState } from "store/types";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "router/types";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
import SimpleButton from "components/SimpleButton";

const DemoDataBox = () => {
  const token = useSelector((state: AppState) => state.auth.token);
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <Box className="snackbar">
      <Box onClick={() => navigate(ROUTES.Sellers)}>
        <Box className="upArrow">
          <img src={UpArrowIcon} />
        </Box>

        <h3>
          {intl.formatMessage({
            id: I18nKey.DEMO_DATA_DISPLAY,
          })}
        </h3>
        <p className="desktopText">
          {!token
            ? intl.formatMessage({
                id: I18nKey.LOGIN_TO,
              })
            : ""}

          {intl.formatMessage({
            id: I18nKey.SELLER_ACCOUNT,
          })}
        </p>
        <p className="mobileText">
          {intl.formatMessage({
            id: I18nKey.MOBILE_TEXT_OPTIMIZE,
          })}
        </p>
      </Box>
      {!token && (
        <SimpleButton
          text=" Exit Demo "
          className="exitDemo"
          onClick={() => navigate(ROUTES.Main)}
          exitDemoStyles
        ></SimpleButton>
      )}
    </Box>
  );
};

export default DemoDataBox;
